import React, { useEffect, Fragment, memo } from 'react';
export function Faq() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-263">
      <div className="legal-hero" data-id="element-264">
        <p className="legal-overline" data-id="element-265">Todo lo que necesitas saber</p>
        <h1 className="legal-title" data-id="element-266">Preguntas frecuentes</h1>
        <p className="legal-subtitle" data-id="element-267">
          Si tienes una duda que no está aquí, escríbenos por WhatsApp.
        </p>
      </div>
      <div className="faq-grid" data-id="element-268">
        {/* SOBRE EL PRODUCTO */}
        <div className="faq-categoria" data-id="element-269">
          <h2 className="faq-categoria-titulo" data-id="element-270">Sobre el producto</h2>
          <div className="faq-item" data-id="element-271">
            <h3 data-id="element-272">¿De qué están hechas las velas SAVIA?</h3>
            <p data-id="element-273">
              100% cera de soya vegetal, libre de parafina y derivados del
              petróleo. Usamos fragrancias de alta calidad con las notas
              indicadas en cada producto. La mecha es de algodón natural.
            </p>
          </div>
          <div className="faq-item" data-id="element-274">
            <h3 data-id="element-275">¿Cuánto dura una vela SAVIA?</h3>
            <p data-id="element-276">
              Las velas de 210g tienen una duración aproximada de 40 a 50 horas
              de quemado continuo, dependiendo del entorno y las corrientes de
              aire. Para mayor duración, quémala en sesiones de 2 a 3 horas
              máximo.
            </p>
          </div>
          <div className="faq-item" data-id="element-277">
            <h3 data-id="element-278">¿Las velas son tóxicas o peligrosas?</h3>
            <p data-id="element-279">
              No. La cera de soya es completamente vegetal y no produce los
              gases tóxicos que libera la parafina. Es una opción segura para
              hogares con mascotas y niños, aunque siempre recomendamos usar las
              velas bajo supervisión de un adulto.
            </p>
          </div>
          <div className="faq-item" data-id="element-280">
            <h3 data-id="element-281">¿Por qué mi vela se ve diferente a la foto?</h3>
            <p data-id="element-282">
              Cada vela es hecha a mano. Pueden existir variaciones sutiles en
              superficie, color y acabado entre piezas — esto es una
              característica del proceso artesanal, no un defecto. Lo que no
              varía nunca es la fragancia.
            </p>
          </div>
          <div className="faq-item" data-id="element-283">
            <h3 data-id="element-284">¿Qué es la "memoria del melt pool"?</h3>
            <p data-id="element-285">
              La primera vez que enciendes tu vela, déjala quemar hasta que toda
              la superficie esté líquida (aprox. 2–3 horas). Esto evita el
              "tunneling" y garantiza que aproveches toda la cera.
            </p>
          </div>
        </div>
        {/* SOBRE LOS PEDIDOS */}
        <div className="faq-categoria" data-id="element-286">
          <h2 className="faq-categoria-titulo" data-id="element-287">Pedidos y envíos</h2>
          <div className="faq-item" data-id="element-288">
            <h3 data-id="element-289">¿Cuándo llega mi pedido?</h3>
            <p data-id="element-290">
              Producimos en 2–4 días hábiles después del pago. El envío toma 1–2
              días adicionales en Bogotá y 3–7 días en el resto del país. Total
              estimado: entre 3 y 11 días hábiles.
            </p>
          </div>
          <div className="faq-item" data-id="element-291">
            <h3 data-id="element-292">¿Puedo hacer un pedido personalizado?</h3>
            <p data-id="element-293">
              Para pedidos corporativos, kits personalizados o cantidades
              mayores a 10 unidades, escríbenos directamente por WhatsApp.
              Tenemos opciones especiales para regalos empresariales y eventos.
            </p>
          </div>
          <div className="faq-item" data-id="element-294">
            <h3 data-id="element-295">¿Puedo recoger mi pedido en Bogotá?</h3>
            <p data-id="element-296">
              Por el momento no contamos con punto de venta físico. Solo
              despachamos a domicilio. Bogotá tiene los tiempos de entrega más
              rápidos.
            </p>
          </div>
          <div className="faq-item" data-id="element-297">
            <h3 data-id="element-298">¿Cómo sé que mi pedido está confirmado?</h3>
            <p data-id="element-299">
              Recibirás una confirmación por WhatsApp o correo electrónico una
              vez procesado el pago. Si después de 2 horas no recibes
              confirmación, escríbenos directamente.
            </p>
          </div>
          <div className="faq-item" data-id="element-300">
            <h3 data-id="element-301">¿Hacen envíos internacionales?</h3>
            <p data-id="element-302">
              Por ahora solo enviamos dentro de Colombia. Si estás fuera del
              país y quieres un pedido, escríbenos — evaluamos caso a caso.
            </p>
          </div>
        </div>
        {/* SOBRE REGALOS */}
        <div className="faq-categoria" data-id="element-303">
          <h2 className="faq-categoria-titulo" data-id="element-304">Regalos y kits</h2>
          <div className="faq-item" data-id="element-305">
            <h3 data-id="element-306">¿El empaque viene listo para regalar?</h3>
            <p data-id="element-307">
              Sí. Cada pedido viene en caja kraft natural con papel mantequilla,
              sticker SAVIA y tarjeta editorial con frase de la colección. No
              enviamos con precio visible — ideal para regalo.
            </p>
          </div>
          <div className="faq-item" data-id="element-308">
            <h3 data-id="element-309">¿Puedo agregar un mensaje personalizado?</h3>
            <p data-id="element-310">
              Sí. Al finalizar la compra puedes escribir el mensaje que quieres
              incluir en la tarjeta. Lo escribimos a mano con la misma intención
              con que hacemos cada vela.
            </p>
          </div>
          <div className="faq-item" data-id="element-311">
            <h3 data-id="element-312">¿Qué incluye el Kit Ritual SAVIA?</h3>
            <p data-id="element-313">
              El Kit Ritual incluye un pebetero SAVIA, un pack de Fragmentos
              Aromáticos × 6 y el aroma que elijas al comprar. Todo en empaque
              kraft premium con tarjeta editorial. Precio: $89.000 COP.
            </p>
          </div>
        </div>
      </div>
    </div>;
}